// "3 / 34" counter on the PDP main image. On phones the thumbnail strip is hidden (see the
// .pr-gallery-count rules in theme.css.liquid), so this is the only cue that the photo swipes
// and how many photos there are. Desktop keeps the strip and never shows the counter.
//
// Reads Flickity's own state from the DOM (the `.is-selected` cell inside `.flickity-slider`)
// rather than hooking Flickity's events: the theme re-renders the section on a variant change
// and replaces `.primgSlider` outright, so a listener bound to the old instance goes deaf. A
// MutationObserver on class changes picks up both swipes and replacements without caring which.
(function () {
  if (window.__pdpGalleryCounterBound) return;
  window.__pdpGalleryCounterBound = true;

  function cellsOf(slider) {
    var track = slider.querySelector('.flickity-slider');
    return track ? track.children : slider.querySelectorAll(':scope > .pr_photo');
  }

  function updateSlider(slider) {
    var host = slider.closest('.pr_lg_img');
    var counter = host && host.querySelector('.pr-gallery-count');
    if (!counter) return;

    var cells = cellsOf(slider);
    var total = cells.length;
    var current = 0;
    for (var i = 0; i < total; i++) {
      if (cells[i].classList.contains('is-selected')) { current = i + 1; break; }
    }

    var text = total > 1 && current ? current + ' / ' + total : '';
    if (counter.textContent !== text) counter.textContent = text;
  }

  // MutationObserver already batches a burst of changes into one callback, and the work is a
  // couple of querySelectorAll calls. Not deferred via requestAnimationFrame: rAF is paused in
  // background tabs, which left the counter blank until the tab was shown.
  function updateAll() {
    var sliders = document.querySelectorAll('.pr_lg_img .primgSlider');
    for (var i = 0; i < sliders.length; i++) updateSlider(sliders[i]);
  }

  new MutationObserver(updateAll).observe(document.body, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['class'],
  });
  updateAll();
})();
